<template>
  <v-select
    :label="$t('Order.originFlgs.title')"
    v-model="model"
    :items="origin_flgs"
    chips
    multiple
    clearable
    deletable-chips
    small-chips
  ></v-select>
</template>

<script>
import consts from "@/consts.js";
import { mapState } from "vuex";

export default {
  name: "SearcherOrderOriginFlgs",

  props: ["value"],

  computed: {
    origin_flgs() {
      if (this.settings && this.settings.shop_custom_name) {
        return consts.orderOriginFlgs();
      } else {
        return [];
      }
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings"]),
  },

  data: () => ({
    model: [],
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.model = this.value;
      },
    },
    model: {
      handler() {
        this.$emit("input", this.model);
      },
    },
  },
};
</script>
